import React from 'react';

export const LoadingSpinner = ({ className = '' }) => {
  return (
    <div
      className={`loading-spinner ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
};